import { ca } from '@cian/analytics';

export type TPageExtra = {
  review_id?: string;
  question_id?: string;
  type: string;
  rating: number | null;
};

export type TPage = {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: TPageExtra;
};

export function trackNewAnswerSubmit(page: TPage) {
  ca('eventSite', {
    action: 'Success',
    category: 'NewbuildingReviews',
    label: 'Reply',
    name: 'oldevent',
    useLastProducts: true,
    page,
  });
}
